import { render, staticRenderFns } from "./industruReport.vue?vue&type=template&id=1ff19e06&scoped=true"
import script from "./industruReport.vue?vue&type=script&lang=js"
export * from "./industruReport.vue?vue&type=script&lang=js"
import style0 from "./industruReport.vue?vue&type=style&index=0&id=1ff19e06&prod&lang=scss&scoped=true"
import style1 from "./industruReport.vue?vue&type=style&index=1&id=1ff19e06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff19e06",
  null
  
)

export default component.exports